import { NextApiRequestQuery } from 'next/dist/server/api-utils';
import fetcher, { MethodEnum } from 'utils/helpers/browser/newFetcher';

export class PitchService {
    getList = async (query: NextApiRequestQuery): Promise<any> => {
        return await fetcher(`/api/pitch/list`, MethodEnum.GET, query);
    };
}
